import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { UserRound } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useSite } from '@/components/landing/site-provider'

interface AccountLinkProps {
    className?: string
}

/* Icon button to the account area, or to the login page for guests. */
const AccountLink: FC<AccountLinkProps> = ({ className }): ReactNode => {
    const { user } = useSite()
    const label = user ? `Akun saya (${user.name})` : 'Masuk atau daftar'

    return (
        <Link
            href={user ? '/akun' : '/masuk'}
            aria-label={label}
            title={label}
            className={cn(
                'relative place-items-center text-cream/80 transition-colors hover:bg-cream/10 hover:text-cream focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-crema',
                className
            )}
        >
            <UserRound aria-hidden className='size-4' />

            {user && (
                <span aria-hidden className='absolute right-1.5 top-1.5 size-2 rounded-full bg-crema ring-2 ring-espresso' />
            )}
        </Link>
    )
}

export default AccountLink
